import React from 'react';
import {DividedList, DividedListProps} from './DividedList';
import {GridContainer} from '../grid';

export const DividedListWithContainer = (props: DividedListProps): JSX.Element | null => {
    return (
        <GridContainer>
            <DividedList {...props} />
        </GridContainer>
    );
};
